import { Api } from '@/services/Api';
export default {
  getFileCategoryByCriteria(body = { keyword: '' }) {
    return Api().post('/FileCategory/GetFileCategorybyCriteria', body);
  },
  getFileCategory(id) {
    return Api().get(`/FileCategory/${id}`);
  },
  saveFileCategory(body) {
    return Api().post(`/FileCategory`, body);
  },
  deleteFileCategory(body) {
    return Api().post(`/FileCategory/DeleteFileCategory`, body);
  },
  postFileCategory(body) {
    return Api().post(`/FileCategory/PostFileCategory`, body);
  }
};
